// source: messages.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.org.couchers.api.conversations.HostRequestStatus', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.Message', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.Message.ContentCase', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentChatCreated', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentChatEdited', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentText', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentUserInvited', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentUserLeft', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentUserMadeAdmin', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentUserRemoved', null, global);
goog.exportSymbol('proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentText = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentText, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentText.displayName = 'proto.org.couchers.api.conversations.MessageContentText';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentChatCreated = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentChatCreated, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentChatCreated.displayName = 'proto.org.couchers.api.conversations.MessageContentChatCreated';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentChatEdited = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentChatEdited, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentChatEdited.displayName = 'proto.org.couchers.api.conversations.MessageContentChatEdited';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentUserInvited = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentUserInvited, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentUserInvited.displayName = 'proto.org.couchers.api.conversations.MessageContentUserInvited';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentUserLeft = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentUserLeft, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentUserLeft.displayName = 'proto.org.couchers.api.conversations.MessageContentUserLeft';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentUserMadeAdmin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.displayName = 'proto.org.couchers.api.conversations.MessageContentUserMadeAdmin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.displayName = 'proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentUserRemoved, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentUserRemoved.displayName = 'proto.org.couchers.api.conversations.MessageContentUserRemoved';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.displayName = 'proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.api.conversations.Message = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.couchers.api.conversations.Message.oneofGroups_);
};
goog.inherits(proto.org.couchers.api.conversations.Message, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.api.conversations.Message.displayName = 'proto.org.couchers.api.conversations.Message';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentText.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentText.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentText} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentText.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentText}
 */
proto.org.couchers.api.conversations.MessageContentText.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentText;
  return proto.org.couchers.api.conversations.MessageContentText.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentText} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentText}
 */
proto.org.couchers.api.conversations.MessageContentText.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentText.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentText.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentText} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentText.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.org.couchers.api.conversations.MessageContentText.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.api.conversations.MessageContentText} returns this
 */
proto.org.couchers.api.conversations.MessageContentText.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentChatCreated.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentChatCreated.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentChatCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentChatCreated.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentChatCreated}
 */
proto.org.couchers.api.conversations.MessageContentChatCreated.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentChatCreated;
  return proto.org.couchers.api.conversations.MessageContentChatCreated.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentChatCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentChatCreated}
 */
proto.org.couchers.api.conversations.MessageContentChatCreated.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentChatCreated.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentChatCreated.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentChatCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentChatCreated.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentChatEdited.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentChatEdited.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentChatEdited} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentChatEdited.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentChatEdited}
 */
proto.org.couchers.api.conversations.MessageContentChatEdited.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentChatEdited;
  return proto.org.couchers.api.conversations.MessageContentChatEdited.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentChatEdited} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentChatEdited}
 */
proto.org.couchers.api.conversations.MessageContentChatEdited.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentChatEdited.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentChatEdited.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentChatEdited} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentChatEdited.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentUserInvited.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentUserInvited} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetUserId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserInvited}
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentUserInvited;
  return proto.org.couchers.api.conversations.MessageContentUserInvited.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserInvited} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserInvited}
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTargetUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentUserInvited.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserInvited} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 target_user_id = 1;
 * @return {number}
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.prototype.getTargetUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.conversations.MessageContentUserInvited} returns this
 */
proto.org.couchers.api.conversations.MessageContentUserInvited.prototype.setTargetUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentUserLeft.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentUserLeft.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentUserLeft} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserLeft.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserLeft}
 */
proto.org.couchers.api.conversations.MessageContentUserLeft.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentUserLeft;
  return proto.org.couchers.api.conversations.MessageContentUserLeft.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserLeft} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserLeft}
 */
proto.org.couchers.api.conversations.MessageContentUserLeft.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentUserLeft.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentUserLeft.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserLeft} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserLeft.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentUserMadeAdmin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetUserId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserMadeAdmin}
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentUserMadeAdmin;
  return proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserMadeAdmin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserMadeAdmin}
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTargetUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserMadeAdmin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 target_user_id = 1;
 * @return {number}
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.prototype.getTargetUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.conversations.MessageContentUserMadeAdmin} returns this
 */
proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.prototype.setTargetUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetUserId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin}
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin;
  return proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin}
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTargetUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 target_user_id = 1;
 * @return {number}
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.prototype.getTargetUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin} returns this
 */
proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.prototype.setTargetUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentUserRemoved.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentUserRemoved} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetUserId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserRemoved}
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentUserRemoved;
  return proto.org.couchers.api.conversations.MessageContentUserRemoved.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserRemoved} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentUserRemoved}
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTargetUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentUserRemoved.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentUserRemoved} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetUserId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 target_user_id = 1;
 * @return {number}
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.prototype.getTargetUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.conversations.MessageContentUserRemoved} returns this
 */
proto.org.couchers.api.conversations.MessageContentUserRemoved.prototype.setTargetUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged}
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged;
  return proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged}
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.couchers.api.conversations.HostRequestStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional HostRequestStatus status = 1;
 * @return {!proto.org.couchers.api.conversations.HostRequestStatus}
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.prototype.getStatus = function() {
  return /** @type {!proto.org.couchers.api.conversations.HostRequestStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.couchers.api.conversations.HostRequestStatus} value
 * @return {!proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged} returns this
 */
proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.couchers.api.conversations.Message.oneofGroups_ = [[4,5,6,7,8,9,10,11,12]];

/**
 * @enum {number}
 */
proto.org.couchers.api.conversations.Message.ContentCase = {
  CONTENT_NOT_SET: 0,
  TEXT: 4,
  CHAT_CREATED: 5,
  CHAT_EDITED: 6,
  USER_INVITED: 7,
  USER_LEFT: 8,
  USER_MADE_ADMIN: 9,
  USER_REMOVED_ADMIN: 10,
  HOST_REQUEST_STATUS_CHANGED: 11,
  GROUP_CHAT_USER_REMOVED: 12
};

/**
 * @return {proto.org.couchers.api.conversations.Message.ContentCase}
 */
proto.org.couchers.api.conversations.Message.prototype.getContentCase = function() {
  return /** @type {proto.org.couchers.api.conversations.Message.ContentCase} */(jspb.Message.computeOneofCase(this, proto.org.couchers.api.conversations.Message.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.api.conversations.Message.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.api.conversations.Message.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.api.conversations.Message} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.Message.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    authorUserId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    text: (f = msg.getText()) && proto.org.couchers.api.conversations.MessageContentText.toObject(includeInstance, f),
    chatCreated: (f = msg.getChatCreated()) && proto.org.couchers.api.conversations.MessageContentChatCreated.toObject(includeInstance, f),
    chatEdited: (f = msg.getChatEdited()) && proto.org.couchers.api.conversations.MessageContentChatEdited.toObject(includeInstance, f),
    userInvited: (f = msg.getUserInvited()) && proto.org.couchers.api.conversations.MessageContentUserInvited.toObject(includeInstance, f),
    userLeft: (f = msg.getUserLeft()) && proto.org.couchers.api.conversations.MessageContentUserLeft.toObject(includeInstance, f),
    userMadeAdmin: (f = msg.getUserMadeAdmin()) && proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.toObject(includeInstance, f),
    userRemovedAdmin: (f = msg.getUserRemovedAdmin()) && proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.toObject(includeInstance, f),
    hostRequestStatusChanged: (f = msg.getHostRequestStatusChanged()) && proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.toObject(includeInstance, f),
    groupChatUserRemoved: (f = msg.getGroupChatUserRemoved()) && proto.org.couchers.api.conversations.MessageContentUserRemoved.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.api.conversations.Message}
 */
proto.org.couchers.api.conversations.Message.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.api.conversations.Message;
  return proto.org.couchers.api.conversations.Message.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.api.conversations.Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.api.conversations.Message}
 */
proto.org.couchers.api.conversations.Message.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMessageId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAuthorUserId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    case 4:
      var value = new proto.org.couchers.api.conversations.MessageContentText;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentText.deserializeBinaryFromReader);
      msg.setText(value);
      break;
    case 5:
      var value = new proto.org.couchers.api.conversations.MessageContentChatCreated;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentChatCreated.deserializeBinaryFromReader);
      msg.setChatCreated(value);
      break;
    case 6:
      var value = new proto.org.couchers.api.conversations.MessageContentChatEdited;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentChatEdited.deserializeBinaryFromReader);
      msg.setChatEdited(value);
      break;
    case 7:
      var value = new proto.org.couchers.api.conversations.MessageContentUserInvited;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentUserInvited.deserializeBinaryFromReader);
      msg.setUserInvited(value);
      break;
    case 8:
      var value = new proto.org.couchers.api.conversations.MessageContentUserLeft;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentUserLeft.deserializeBinaryFromReader);
      msg.setUserLeft(value);
      break;
    case 9:
      var value = new proto.org.couchers.api.conversations.MessageContentUserMadeAdmin;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.deserializeBinaryFromReader);
      msg.setUserMadeAdmin(value);
      break;
    case 10:
      var value = new proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.deserializeBinaryFromReader);
      msg.setUserRemovedAdmin(value);
      break;
    case 11:
      var value = new proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.deserializeBinaryFromReader);
      msg.setHostRequestStatusChanged(value);
      break;
    case 12:
      var value = new proto.org.couchers.api.conversations.MessageContentUserRemoved;
      reader.readMessage(value,proto.org.couchers.api.conversations.MessageContentUserRemoved.deserializeBinaryFromReader);
      msg.setGroupChatUserRemoved(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.api.conversations.Message.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.api.conversations.Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.api.conversations.Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.api.conversations.Message.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getAuthorUserId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.couchers.api.conversations.MessageContentText.serializeBinaryToWriter
    );
  }
  f = message.getChatCreated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.couchers.api.conversations.MessageContentChatCreated.serializeBinaryToWriter
    );
  }
  f = message.getChatEdited();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.couchers.api.conversations.MessageContentChatEdited.serializeBinaryToWriter
    );
  }
  f = message.getUserInvited();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.couchers.api.conversations.MessageContentUserInvited.serializeBinaryToWriter
    );
  }
  f = message.getUserLeft();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.org.couchers.api.conversations.MessageContentUserLeft.serializeBinaryToWriter
    );
  }
  f = message.getUserMadeAdmin();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.org.couchers.api.conversations.MessageContentUserMadeAdmin.serializeBinaryToWriter
    );
  }
  f = message.getUserRemovedAdmin();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin.serializeBinaryToWriter
    );
  }
  f = message.getHostRequestStatusChanged();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged.serializeBinaryToWriter
    );
  }
  f = message.getGroupChatUserRemoved();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.org.couchers.api.conversations.MessageContentUserRemoved.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 message_id = 1;
 * @return {number}
 */
proto.org.couchers.api.conversations.Message.prototype.getMessageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.setMessageId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 author_user_id = 2;
 * @return {number}
 */
proto.org.couchers.api.conversations.Message.prototype.getAuthorUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.setAuthorUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.api.conversations.Message.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MessageContentText text = 4;
 * @return {?proto.org.couchers.api.conversations.MessageContentText}
 */
proto.org.couchers.api.conversations.Message.prototype.getText = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentText} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentText, 4));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentText|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setText = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearText = function() {
  return this.setText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasText = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MessageContentChatCreated chat_created = 5;
 * @return {?proto.org.couchers.api.conversations.MessageContentChatCreated}
 */
proto.org.couchers.api.conversations.Message.prototype.getChatCreated = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentChatCreated} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentChatCreated, 5));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentChatCreated|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setChatCreated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearChatCreated = function() {
  return this.setChatCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasChatCreated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MessageContentChatEdited chat_edited = 6;
 * @return {?proto.org.couchers.api.conversations.MessageContentChatEdited}
 */
proto.org.couchers.api.conversations.Message.prototype.getChatEdited = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentChatEdited} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentChatEdited, 6));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentChatEdited|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setChatEdited = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearChatEdited = function() {
  return this.setChatEdited(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasChatEdited = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MessageContentUserInvited user_invited = 7;
 * @return {?proto.org.couchers.api.conversations.MessageContentUserInvited}
 */
proto.org.couchers.api.conversations.Message.prototype.getUserInvited = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentUserInvited} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentUserInvited, 7));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentUserInvited|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setUserInvited = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearUserInvited = function() {
  return this.setUserInvited(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasUserInvited = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional MessageContentUserLeft user_left = 8;
 * @return {?proto.org.couchers.api.conversations.MessageContentUserLeft}
 */
proto.org.couchers.api.conversations.Message.prototype.getUserLeft = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentUserLeft} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentUserLeft, 8));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentUserLeft|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setUserLeft = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearUserLeft = function() {
  return this.setUserLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasUserLeft = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional MessageContentUserMadeAdmin user_made_admin = 9;
 * @return {?proto.org.couchers.api.conversations.MessageContentUserMadeAdmin}
 */
proto.org.couchers.api.conversations.Message.prototype.getUserMadeAdmin = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentUserMadeAdmin} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentUserMadeAdmin, 9));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentUserMadeAdmin|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setUserMadeAdmin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearUserMadeAdmin = function() {
  return this.setUserMadeAdmin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasUserMadeAdmin = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional MessageContentUserRemovedAdmin user_removed_admin = 10;
 * @return {?proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin}
 */
proto.org.couchers.api.conversations.Message.prototype.getUserRemovedAdmin = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin, 10));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentUserRemovedAdmin|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setUserRemovedAdmin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearUserRemovedAdmin = function() {
  return this.setUserRemovedAdmin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasUserRemovedAdmin = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional MessageContentHostRequestStatusChanged host_request_status_changed = 11;
 * @return {?proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged}
 */
proto.org.couchers.api.conversations.Message.prototype.getHostRequestStatusChanged = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged, 11));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentHostRequestStatusChanged|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setHostRequestStatusChanged = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearHostRequestStatusChanged = function() {
  return this.setHostRequestStatusChanged(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasHostRequestStatusChanged = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional MessageContentUserRemoved group_chat_user_removed = 12;
 * @return {?proto.org.couchers.api.conversations.MessageContentUserRemoved}
 */
proto.org.couchers.api.conversations.Message.prototype.getGroupChatUserRemoved = function() {
  return /** @type{?proto.org.couchers.api.conversations.MessageContentUserRemoved} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.api.conversations.MessageContentUserRemoved, 12));
};


/**
 * @param {?proto.org.couchers.api.conversations.MessageContentUserRemoved|undefined} value
 * @return {!proto.org.couchers.api.conversations.Message} returns this
*/
proto.org.couchers.api.conversations.Message.prototype.setGroupChatUserRemoved = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.org.couchers.api.conversations.Message.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.api.conversations.Message} returns this
 */
proto.org.couchers.api.conversations.Message.prototype.clearGroupChatUserRemoved = function() {
  return this.setGroupChatUserRemoved(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.api.conversations.Message.prototype.hasGroupChatUserRemoved = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * @enum {number}
 */
proto.org.couchers.api.conversations.HostRequestStatus = {
  HOST_REQUEST_STATUS_PENDING: 0,
  HOST_REQUEST_STATUS_ACCEPTED: 1,
  HOST_REQUEST_STATUS_REJECTED: 2,
  HOST_REQUEST_STATUS_CONFIRMED: 3,
  HOST_REQUEST_STATUS_CANCELLED: 4
};

goog.object.extend(exports, proto.org.couchers.api.conversations);
